'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = getEntitySelectionState;
function getEntitySelectionState(contentState, entityKey) {
    var blockMap = contentState.getBlockMap();
    console.log('>> blockmap', blockMap.toSource());
    // const selectionKey = selectionState.getAnchorKey();
    // const selectionOffset = selectionState.getAnchorOffset();
    // const block = contentState.getBlockForKey(selectionKey);
    // const blockKey = block.getKey();
    //
    // let entitySelection;
    // getRangesForDraftEntity(block, entityKey).forEach((range) => {
    //   if (range.start <= selectionOffset && selectionOffset <= range.end) {
    //     entitySelection = new SelectionState({
    //       anchorOffset: range.start,
    //       anchorKey: blockKey,
    //       focusOffset: range.end,
    //       focusKey: blockKey,
    //       isBackward: false,
    //       hasFocus: selectionState.getHasFocus(),
    //     });
    //   }
    // });
    // return entitySelection;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/.0.1.0@rc-editor-utils/lib/getEntitySelectionState.js
// module id = 328
// module chunks = 0